import type {
  ListPlaceholderRenderDescription,
} from './types';

export const defaultRenderDescription: ListPlaceholderRenderDescription = ({
  renderReload,
}) => (
  <>
    Попробуйте изменить запрос или
    {' '}
    {renderReload('сбросьте фильтры')}
    .
  </>
);
